import {createFileRoute} from '@tanstack/react-router';
import {HomeLayout} from '@features/flow/components/HomeLayout';
import {CreditsView} from '@features/credits/CreditsView';

export const Route = createFileRoute('/credits')({component: CreditsPage});

function CreditsPage() {
  return (
    <HomeLayout currentView='credits' hideHeader>
      <title>Banani | Credits</title>
      <CreditsView />
    </HomeLayout>
  );
}
